import { track as trackNavEvent } from 'js/shared/navigation'

$('.header--external').on('click', '.js-c-mega-nav__dropdown__list-li a', async event => {
  const name = event.target.innerText
  trackNavEvent('click',  'Mega Nav Menu - ' + name)
})
